import { useCallback } from 'react';
import { getReportDefinitionUseCase } from '@reports/application/use-cases';
import type { ReportType } from '@reports/domain/types';
import type { Report } from '@reports/domain/entities';

/**
 * Hook to get report definition by type
 *
 * Uses the GetReportDefinitionUseCase to fetch report configuration
 * from the registry. This is synchronous (no API call).
 *
 * @returns {Object} Report definition getter function
 * @returns {Function} returns.getReportDefinition - Function to get report by type
 *
 * @example
 * const { getReportDefinition } = useReportDefinition();
 * const salesReport = getReportDefinition(ReportTypes.SALES);
 */
export const useReportDefinition = () => {
  const useCase = getReportDefinitionUseCase();

  const getReportDefinition = useCallback(
    (type: ReportType): Report => {
      return useCase.execute(type);
    },
    [useCase],
  );

  return { getReportDefinition };
};
